// 此文件是通过脚本生成的，直接编辑无效！！！

// 不需要导航框架的页面路径
export const noFrames = [
    '/login'
];

// 不需要登录就可以访问的页面路径
export const noAuths = [
    '/login'
];

// 需要keep alive 页面
export const keepAlives = [
    {
        path: '/iframe_page_/:src',
        keepAlive: true,
    }
];

// 页面路由配置
export default [
    {
        path: '/bridge/manager',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/device/bridge/index.jsx'),
    },
    {
        path: '/device/manager',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/device/query/index.jsx'),
    },
    {
        path: '/device/unbind',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/device/unbind/index.jsx'),
    },
    {
        path: '/example/table-editable',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/examples/table-editable/index.jsx'),
    },
    {
        path: '/financial/auto/cash',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/financial/auto/index.jsx'),
    },
    {
        path: '/financial/cash/examine',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/financial/examine/index.jsx'),
    },
    {
        path: '/financial/manager',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/financial/manager/index.jsx'),
    },
    {
        path: '/gen',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/gen/index.jsx'),
    },
    {
        path: '/',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/home/index.jsx'),
    },
    {
        path: '/iframe_page_/:src',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/iframe/index.jsx'),
    },
    {
        path: '/login',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/login/index.jsx'),
    },
    {
        path: '/merchant/channel/list',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/merchant/channel/index.jsx'),
    },
    {
        path: '/merchant/merchant/list',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/merchant/merchant/index.jsx'),
    },
    {
        path: '/merchant/use-rate/list',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/merchant/use-rate/index.jsx'),
    },
    {
        path: '/order/manager',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/order/manager/index.jsx'),
    },
    {
        path: '/order/statistics',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/order/statis/index.jsx'),
    },
    {
        path: '/device/price/builtIn',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/place/builtIn/index.jsx'),
    },
    {
        path: '/place/channel',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/place/channel/index.jsx'),
    },
    {
        path: '/place/manager',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/place/manager/index.jsx'),
    },
    {
        path: '/device/price',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/place/price/index.jsx'),
    },
    {
        path: '/place/share',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/place/share/index.jsx'),
    },
    {
        path: '/system/login/log',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/system/loginlog/index.jsx'),
    },
    {
        path: '/system/menus',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/system/menus/index.jsx'),
    },
    {
        path: '/system/operate/log',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/system/operatelog/index.jsx'),
    },
    {
        path: '/system/optimize',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/system/optimize/index.jsx'),
    },
    {
        path: '/system/property',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/system/property/index.jsx'),
    },
    {
        path: '/system/roles',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/system/roles/index.jsx'),
    },
    {
        path: '/system/user',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/system/users/index.jsx'),
    },
    {
        path: '/users/:id',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/user-center/index.jsx'),
    },
    {
        path: '/warning',
        component: () => import('/Users/ych/IdeaWorkspace/kunpeng/v1.0/kunpeng-webapp/src/pages/warning/index.jsx'),
    }
];
    